import { createContext, useContext, useEffect, useState, useRef } from "react";
import { refreshToken } from "../services/Access";
import { saveAccessToken, getTokenData } from "../utils/Utils";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    checkAuth();
  }, []);

  async function checkAuth() {
    const token = getTokenData();

    if (token?.id) {
      setUser(token);
    } else {
      refreshToken()
        .then((response) => {
          if (response?.data?.success) {
            saveAccessToken(response?.data?.msg);
            const token = getTokenData();
            setUser(token);
          } else {
            setUser(null);
          }
        })
        .catch(() => {
          setUser(null);
        });
    }

    setLoading(false);
  }

  return (
    <AuthContext.Provider value={{ user, setUser, checkAuth }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
